module.exports = __webpack_public_path__ + "static/media/title_bg_7.46d695d2.png";